var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { DeviceActions } from './devices.actions';
import { deviceUID, tryMedia, releaseStream } from './devices.utils';
import { createEpicMiddleware, ofType } from 'redux-observable';
import { of, from, zip } from 'rxjs';
import { catchError, map, mapTo, mergeMap, tap } from 'rxjs/operators';
var DeviceEpics = /** @class */ (function () {
    function DeviceEpics(deviceActions) {
        this.deviceActions = deviceActions;
    }
    DeviceEpics.prototype.createEpics = function () {
        return [
            createEpicMiddleware(this.fallbackInputEpic.bind(this))
        ];
    };
    DeviceEpics.prototype.fallbackInputEpic = function (action$) {
        var _this = this;
        return action$.pipe(ofType(DeviceActions.INPUT_FALLBACK_START), mergeMap(function (_a) {
            var payload = _a.payload;
            if (!payload) {
                return of(_this.deviceActions.inputFallbackError({
                    errorCode: 'FALLBACK:DEVICE_STATE_EXPECTED',
                    message: 'No devices state.'
                }));
            }
            return audioVideoInputFallback(payload.selectedInputDevice, payload.selectedVideoInputDevice, payload).pipe(map(function (nextDevices) { return _this.deviceActions.finishInputFallback(nextDevices); }));
        }));
    };
    return DeviceEpics;
}());
export { DeviceEpics };
function tryDeviceByKind(device) {
    if (device.kind === 'audioinput') {
        return from(tryMedia({
            audio: {
                deviceId: { exact: device.deviceId }
            },
            video: false
        }));
    }
    else {
        return from(tryMedia({
            audio: false,
            video: {
                deviceId: { exact: device.deviceId }
            }
        }));
    }
}
export function audioVideoInputFallback(audioDevice, videoDevice, deviceState) {
    if (!deviceState) {
        return of({ audioDevice: (audioDevice || null), videoDevice: (videoDevice || null) });
    }
    return zip(inputFallBack(audioDevice, deviceState.availableInputDevices, deviceState.selectedInputDeviceHistory), inputFallBack(videoDevice, deviceState.availableVideoInputDevices, deviceState.selectedVideoInputDeviceHistory)).pipe(map(function (_a) {
        var _b = __read(_a, 2), nextAudioDevice = _b[0], nextVideoDevice = _b[1];
        return ({ audioDevice: nextAudioDevice, videoDevice: nextVideoDevice });
    }));
}
export function inputFallBack(failedDevice, availableDevices, history) {
    if (!failedDevice) {
        return of(null);
    }
    var failedDevices = [];
    if (!availableDevices) {
        return of(null);
    }
    var nextDeviceUID;
    return of('fallback chain start').pipe(map(function () { return selectNextInput(availableDevices, history || [], failedDevices); }), mergeMap(function (nextDevice) {
        if (nextDevice) {
            nextDeviceUID = deviceUID(nextDevice);
            return tryDeviceByKind(nextDevice).pipe(tap(releaseStream), mapTo(nextDevice));
        }
        return of(null);
    }), catchError(function (error, caught) {
        if (error.errorCode === 'MEDIA_ERROR' && failedDevice) {
            failedDevices.push(nextDeviceUID);
            return caught; // retry chain
        }
        return of(null);
    }));
}
export function selectNextInput(availableDevices, history, failedDevices) {
    var availableDeviceNotFailed = availableDevices.filter(function (d) { return !failedDevices.includes(deviceUID(d)); });
    // prioritize history
    for (var i = history.length - 1; i >= 0; i--) {
        for (var j = 0; j < availableDeviceNotFailed.length; j++) {
            if (history[i] === deviceUID(availableDeviceNotFailed[j])) {
                return availableDeviceNotFailed[j];
            }
        }
    }
    var availableDeviceNotFailedNotInHistory = availableDeviceNotFailed.filter(function (d) { return !history.includes(deviceUID(d)); });
    for (var i = 0; i < availableDeviceNotFailedNotInHistory.length; i++) {
        return availableDeviceNotFailedNotInHistory[i];
    }
    return null;
}
//# sourceMappingURL=devices.epics.js.map